// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { twoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

twoButtonModalStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        flex-wrap: wrap;
    `,
};

twoButtonModalStyles.cancelButton = {
    ...twoButtonModalStyles.cancelButton,
    css: css`
        margin-right: 10px;
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-right: 0;
            margin-top: 10px;
            order: 1;
        }
    `,
};

twoButtonModalStyles.submitButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
